import { numberToCurrencyString } from 'further-ui/utils';
import { Row } from 'further-ui/components/Layout';
import StaticField from 'further-ui/components/StaticField';
import api from 'lib/trpcClient';
import React from 'react';

type Props = {
  vehicleId: string;
  groupId: string;
};

const OriginalActionSummary: React.FC<Props> = ({ vehicleId, groupId }) => {
  const [actionData] = api.incomeAndExpenses.get.useSuspenseQuery({
    id: groupId,
    vehicleId,
  });

  return (
    <Row spacing="lg">
      <StaticField label="Counterparty">
        {actionData?.counterparty?.name ?? ''}
      </StaticField>
      <StaticField label="Amount">
        {numberToCurrencyString(actionData?.amountIncVatTcy ?? 0, {
          currency: actionData?.currencyCode,
        })}
      </StaticField>
      <StaticField label="Ledger date">
        {actionData?.startDate?.toReadable() ?? ''}
      </StaticField>
    </Row>
  );
};

export default OriginalActionSummary;
